import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { WAREHOUSE_BANK_LINE_ACTION_TYPE } from '../actions';

const initialState = {
  lines: {},
  rateHistory: {},
};

const warehouseBankLinesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case WAREHOUSE_BANK_LINE_ACTION_TYPE.GET_LINES:
        draft.lines = payload.reduce((acc, line) => {
          acc[line.id] = line;

          return acc;
        }, {});
        break;

      case WAREHOUSE_BANK_LINE_ACTION_TYPE.GET_LINE:
      case WAREHOUSE_BANK_LINE_ACTION_TYPE.CREATE_LINE:
      case WAREHOUSE_BANK_LINE_ACTION_TYPE.UPDATE_LINE:
        draft.lines[payload.id] = payload;
        break;

      case WAREHOUSE_BANK_LINE_ACTION_TYPE.DELETE_LINE:
        delete draft.lines[meta.lineId];
        break;

      case WAREHOUSE_BANK_LINE_ACTION_TYPE.MANAGE_ELIGIBILITIES:
        if (draft.lines[meta.lineId]) {
          draft.lines[meta.lineId].eligibilities = payload;
        }

        break;

      case WAREHOUSE_BANK_LINE_ACTION_TYPE.GET_RATE_HISTORY:
        draft.rateHistory[meta.lineId] = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default warehouseBankLinesReducer;
